enum CashFinancingTypeEnum {
    LOAN_WALLET = "LOAN_WALLET",
    CASH_LOAN = "CASH_LOAN"
}

export default CashFinancingTypeEnum;
